import A from "@/common/assets/image/moneyFortune/web3Plus/resultImg/A.webp"
import AM from "@/common/assets/image/moneyFortune/web3Plus/resultImg/AM.webp"
import B from "@/common/assets/image/moneyFortune/web3Plus/resultImg/B.webp"
import BM from "@/common/assets/image/moneyFortune/web3Plus/resultImg/BM.webp"
import C from "@/common/assets/image/moneyFortune/web3Plus/resultImg/C.webp"
import CM from "@/common/assets/image/moneyFortune/web3Plus/resultImg/CM.webp"
import D from "@/common/assets/image/moneyFortune/web3Plus/resultImg/D.webp"
import DM from "@/common/assets/image/moneyFortune/web3Plus/resultImg/DM.webp"
import E from "@/common/assets/image/moneyFortune/web3Plus/resultImg/E.webp"
import EM from "@/common/assets/image/moneyFortune/web3Plus/resultImg/EM.webp"

export const GetAndShare = {
  API: "fortunego-by-kryptogo",
  APIPOST: `${process.env.NEXT_PUBLIC_CMS_HOST}/api/money-fortune2s`,
  copylink: `https://web3plus.bnext.com.tw/planet`,
  shareText: "分享到FB",
  shareURL: `https://www.facebook.com/sharer/sharer.php?u=https://web3plus.bnext.com.tw/planet`,
  resultToUrl: "https://www.kryptogo.com/money-fortune2/csv",
  completeType: "email ",
  OGimg: "https://i.ibb.co/4jc3Nfk/OG-img.png",
  OGtitle: "區塊鏈多重宇宙，你會是哪個星球人?",
  OGurl: "https://web3plus.bnext.com.tw/planet"
}

export const ResultDate = [
  {
    roleID: "智囊團",
    name: "智囊團",

    img: E,
    resultImg: EM
  },
  {
    roleID: "實踐者",
    name: "實踐者",

    img: D,
    resultImg: DM
  },
  {
    roleID: "牽成者",
    name: "牽成者",

    img: B,
    resultImg: BM
  },
  {
    roleID: "拓荒者",
    name: "拓荒者",

    img: C,
    resultImg: CM
  },
  {
    roleID: "鼓吹者",
    name: "鼓吹者",

    img: A,
    resultImg: AM
  }
]
